module.exports = __webpack_public_path__ + "static/coach-ed31b77c13e14738a6d5c27753b81bd4.jpg";